export const EMAIL_PATTERN = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';
export const EMAIL_REGEX = new RegExp(EMAIL_PATTERN);

export const PHONE_PATTERN = '^\\+[1-9]\\d{6,14}$';
export const PHONE_REGEX = new RegExp(PHONE_PATTERN);

export const ALPHA_SPACE_PATTERN = '^[a-zA-Z ]*$';
export const ALPHA_SPACE_REGEX = new RegExp(ALPHA_SPACE_PATTERN);

export const OTP_PATTERN = '^\\d{6}$';
export const OTP_REGEX = new RegExp(OTP_PATTERN);
